<template>
  <div class="canner">
    <div @mouseenter="menuHide"><Header class="Header"></Header></div>
    <div class="top-banner">
      <div class="bannerContent">
        <el-menu
          :default-active="path"
          class="el-menu-vertical-demo"
          background-color="#034f92"
          text-color="#fff"
          mode="horizontal"
          @select="menuSelect"
          active-text-color="#034f92"
          unique-opened
          router
        >
          <template v-for="(item, index) in nav_menu_data" v-if="index <= 2">
            <el-menu-item
              :index="item.path"
              @click="menuClick(item.title)"
              style="text-align: center; padding: 0"
              ><div @mouseenter="menuShow(index)">
                {{ item.title }}
              </div></el-menu-item
            >
          </template>
          <template>
            <div
              class="hoverBox"
              v-if="menuFlag"
              @mouseenter="menuShow(8)"
              @mouseleave="menuHide"
            >
              <div class="boldfont">
                <div
                  class="lineBox"
                  v-for="(item, index) in nav_menu_data"
                  v-if="index > 2"
                  @click="menuPlusClick(item)"
                >
                  <div class="item">{{ item.title }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-menu>
        <div style="margin: 0 10px;">
          <el-divider direction="vertical" ></el-divider>
        </div>
        <div
          v-for="(item, index) in associationList"
          class="bannerText"
          @mouseleave="menuHide2"
          @click="actionBtn(item)"
        > 
        <div>{{item.t1}}</div>
        <div>{{item.t2}}</div>
          <!-- {{ item.name }} -->
        </div>
        <!-- <div @mouseenter="menuShow2" @mouseleave="menuHide2" class="bannerText">
          更多<i class="el-icon-caret-bottom"></i>
          <template>
            <div
              class="hoverBox"
              v-if="menuFlag2"
              
              @mouseleave="menuHide2"
            >
              <div class="boldfont">
                <div
                  class="lineBox"
                  v-for="(item, index) in associationList"
                  v-if="index > 3"
                  @click="actionBtn(item)"
                >
                  <div class="item" :title="item.name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </template>
        </div> -->
      </div>
    </div>
    <div class="main">
      <div class="left" :style="{ width: path != '/' ? '100%' : '1200px' }">
        <transition :name="transitionName">
          <router-view
            :tabsTypeName="typeName"
            :tabsTypeId="typeId"
          ></router-view>
        </transition>
      </div>
    </div>
    <Footer class="Footer"></Footer>
    <float-view
      v-if="showView"
      :json="json"
      @closeView="showView = false"
    ></float-view>
    <float-view
      v-if="showView2"
      :json="json2"
      @closeView="showView2 = false"
    ></float-view>
  </div>
</template>

<script>
import { hotType, getArticle } from "@/api/main";
import floatView from "@/components/Info/floatView.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Main",
  components: {
    Header,
    floatView,
    Footer,
  },
  data() {
    return {
      showView: false,
      showView2: false,
      menuFlag: false,
      menuFlag2: false,
      json: {
        src: "",
        url: "",
        left: 100,
        top: 400,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: null,
        zIndex: 1500,
        width: null,
        height: null,
        noHoverPause: false, //鼠标经过时不停止，为true时不停止
        cursor: null,
      },
      json2: {
        src: "",
        url: "",
        left: 1000,
        top: 800,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: null,
        zIndex: 1500,
        width: null,
        height: null,
        noHoverPause: false, //鼠标经过时不停止，为true时不停止
        cursor: null,
      },
      transitionName: "",
      userInfo: {},
      path: "/",
      typeName: "",
      typeId: "",
      nav_menu_data: [
        {
          title: "首页",
          path: "/",
        },
        // {
        //   title: "其他信息",
        //   path: "/Content?type=7"
        // }
      ],
      associationList: [
        {
          name: "监理委员会",
          t1: '监理',
          t2: '委员会',
          state: false
        },
        {
          name: "试验检测委员会",
          t1: '试验检测',
          t2: '委员会',
          typeId: '2c9151b4850e8bf5018cd782c60c0120'
        },
        // {
        //   name: "标准化委员会",
        //   t1: '标准化',
        //   t2: '委员会',
        //   typeId: '2c9151b4850e8bf5018cd77d80ea011f'
        // },
        // {
        //   name: "团体标准申报",
        //   state: false
        // },
        // {
        //   name: "企业情况报送",
        //   state: false
        // },
        {
          name: "勘察设计咨询专业委员会",
          t1: '勘察设计咨询',
          t2: '专业委员会',
          typeId: '2c9151b4850e8bf5018f845b1d9701a8'
        },
        {
          name: "国际合作专业委员会",
          t1: '国际合作',
          t2: '专业委员会',
          typeId: '2c9151b4850e8bf5018f845fa8b601a9'
        },
        {
          name: "教育培训与科研工作委员会",
          t1: '教育培训与科研工作',
          t2: '委员会',
          typeId: '2c9151b4850e8bf5018f846109c301ac'
        },
        {
          name: "专家委员会",
          t1: '专家',
          t2: '委员会',
          typeId: '2c9151b4850e8bf5018f8462bbea01af'
        },
        {
          name: "四电专业委员会",
          t1: '四电',
          t2: '专业委员会',
          typeId: '2c9151b4850e8bf5018f8463e88801b2'
        },
        {
          name: "桥梁分会",
          t1: '桥梁',
          t2: '分会',
          typeId: '2c9151b4850e8bf5018f8465498f01b5'
        },
        {
          name: "站房建设专业委员会",
          t1: '站房建设',
          t2: '专业委员会',
          typeId: '2c9151b4850e8bf5018f8466726801b8'
        },
        {
          name: "智能建造分会",
          t1: '智能建造',
          t2: '分会',
          typeId: '2c9151b4850e8bf5018f8467b2c401bb'
        },
      ],
    };
  },
  created() {
    this.showMovingBox();
    this.getHotType();
    this.onRouteChanged();
  },
  methods: {
    menuShow(index) {
      if (index >= 2) {
        this.menuFlag = true;
      } else {
        this.menuFlag = false;
      }
    },
    menuHide() {
      this.menuFlag = false;
    },
    menuShow2(){
      this.menuFlag2 = true;
    },
    menuHide2() {
      this.menuFlag2 = false;
    },
    showMovingBox() {
      getArticle({ id: "2c9151b4850e8bf5018f037fc5930187" }).then((resp) => {
        if (resp.code == 200) {
          var data = resp.data;
          this.json.src = data.url;
          this.json.url = data.introduce;
          this.json.title = data.title;
          this.showView = data.state == "1";
        }
      });
      getArticle({ id: "2c9151b4850e8bf5018f50d68625019b" }).then((resp) => {
        if (resp.code == 200) {
          var data2 = resp.data;
          this.json2.src = data2.url;
          this.json2.url = data2.introduce;
          this.json.title = data2.title;
          this.showView2 = data2.state == "1";
        }
      });
    },
    getHotType() {
      hotType().then((resp) => {
        resp.data.map((el) => {
          var routerItem = {
            title: el.typeName,
            path: `/Content?type=${el.typeName}&typeId=${el.id}`,
            id: el.id,
          };
          this.nav_menu_data.push(routerItem);
        });
      });
    },
    menuSelect(path) {
      if (path != "/") {
        var item = this.nav_menu_data.find(
          (el) => path.split("=")[1].split("&")[0] == el.title
        );
        this.typeName = item.title;
        this.typeId = item.id;
      }
      this.showView = path != "/" ? false : true;
    },
    menuClick(name) {
      document.title = name == "首页" ? "中国铁道工程建设协会" : name;
    },
    menuPlusClick(item) {
      document.title = item.title;
      var routeData = this.$router.resolve({ path: item.path });
      window.open(routeData.href, "_self");
    },
    onRouteChanged() {
      let that = this;
      that.path = that.$route.path;
      if (this.$route.query.type) {
        this.path =
          this.path +
          `?type=${this.$route.query.type}&typeId=${this.$route.query.typeId}`;
      }
    },
    actionBtn(item) {
      if (item.name === "监理委员会") {
        var routeData = this.$router.resolve({
          path: `/committee`,
          params: { deptId: 101 },
        });
        window.open(routeData.href, "_blank");
      } else if (item.name === "企业情况报送") {
        window.open("https://qyphb.carec.org.cn/#/login", "_blank");
      } else if (item.name === "团体标准申报") {
        var routeData = this.$router.resolve({
          path: `/Content?type=立项书&typeId=2c9151b4850e8bf5018d542aaf6b014e&articleId=2c9151b4850e8bf5018d542b87b2014f`,
        });
        window.open(routeData.href, "_self");
      } else {
        var routeData = this.$router.resolve({
          path: `/Content?type=${item.name}&typeId=${item.typeId}`,
        });
        window.open(routeData.href, "_self");
      }
    },
  },
  watch: {
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left";
      } else {
        this.transitionName = "slide-right";
      }
      this.path = to.path;
      if (this.$route.query.type) {
        this.path =
          this.path +
          `?type=${this.$route.query.type}&typeId=${this.$route.query.typeId}`;
      }
    },
  },
};
</script>

<style scoped>
.canner {
  position: absolute;
  z-index: 1000;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: auto;
}
.main {
  /* overflow-y: auto; */
  min-height: 700px;
  position: relative;
  z-index: 10;
  /* padding-bottom: 20px; */
}
.top-banner {
  width: 100%;
  height: 54px;
  
  background: #034f92;
}
.bannerText {
  font-size: 12px;
  /* height: 54px; */
  /* line-height: 54px; */
  color: #ffcc0e;
  font-weight: bold;
  margin: 0 8px;
  min-width: 50px;
  max-width: 110px;
  text-align: center;
  cursor: pointer;
  position: relative;
}
.newText {
  color: #fff !important;
}
.bannerContent {
  width: 1200px;
  display: flex;
  align-items: center;
  margin: 0 auto;
}
.Footer {
  width: 100%;
  margin: 0 auto;
  height: 90px;
}
.left {
  overflow-x: hidden;
  /* width: 1200px; */
  margin: 0 auto;
  /* background: red; */
}
.left-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left-title {
  color: #35567f;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 3px;
  padding: 0 15px;
  margin-left: 5px;
  border-bottom: 2px solid #298df8;
}
.right-img {
  width: 75px;
  margin: 30px 20px 20px;
  height: 75px;
  line-height: 75px;
  text-align: center;
  background: #fff;
  border-radius: 40px;
}
.right-img2 {
  width: 166px;
  height: 166px;
}
.tongdao {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.el-menu-item.is-active {
  background-color: #fff !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item {
  height: 28px;
  margin: 13px 9px;
  line-height: 28px;
  font-size: 16px;
  border-radius: 50px;
  border-bottom: none;
}
.el-menu-item {
  width: 85px;
  text-align: center;
}
.el-menu-vertical-demo {
  position: relative;
}
.el-menu-vertical-demo .hoverBox {
  position: absolute;
  z-index: 100;
  height: 1px;
  width: 85px;
  bottom: -1px;
  right: 0;
}
.el-menu-vertical-demo .hoverBox .boldfont {
  position: absolute;
  width: 82px;
  top: 0px;
  right: 0;
  color: #fff;
  padding: 5px 9px 9px;
  border-top: 3px solid #f7f7f7;
  background: #034f92;
}
.el-menu-vertical-demo .hoverBox .boldfont .item {
  height: 20px;
  line-height: 20px;
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 5px 0;
  border-radius: 14px;
}
.el-menu-vertical-demo .hoverBox .boldfont .lineBox {
  padding: 4px 0;
  cursor: pointer;
  border-bottom: 1px dashed #fff;
}
.el-menu-vertical-demo .hoverBox .boldfont .item:hover {
  background: #023f75;
}

.bannerText .hoverBox {
  position: absolute;
  z-index: 100;
  height: 1px;
  width: 85px;
  bottom: -1px;
  right: -12px;
}
.bannerText .hoverBox .boldfont {
  position: absolute;
  width: 100px;
  top: 0px;
  right: 0;
  color: #fff;
  padding: 5px 9px 9px;
  border-top: 3px solid #f7f7f7;
  background: #034f92;
}
.bannerText .hoverBox .boldfont .item {
  height: 20px;
  line-height: 20px;
  width: 100%;
  text-align: center;
  color: #fff;
  padding: 5px 0;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bannerText .hoverBox .boldfont .lineBox {
  padding: 4px 0;
  cursor: pointer;
  border-bottom: 1px dashed #fff;
  width: 100%;
  
}
.bannerText .hoverBox .boldfont .item:hover {
  background: #023f75;
}
</style>
